import { render, staticRenderFns } from "./NotificationProfileEdit.vue?vue&type=template&id=c612a1de&"
import script from "./NotificationProfileEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports